import { render, staticRenderFns } from "./SignPage.vue?vue&type=template&id=3a080a60&scoped=true&"
import script from "./SignPage.vue?vue&type=script&lang=js&"
export * from "./SignPage.vue?vue&type=script&lang=js&"
import style0 from "./SignPage.vue?vue&type=style&index=0&id=3a080a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a080a60",
  null
  
)

export default component.exports